import OpenAI from 'openai';

const openai = new OpenAI({
  apiKey: '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',
  dangerouslyAllowBrowser: true
});

export async function generateMarketAnalysis(data: string): Promise<string> {
  try {
    const response = await openai.chat.completions.create({
      model: "gpt-4-turbo-preview",
      messages: [
        {
          role: "system",
          content: "You are a cryptocurrency market analyst specializing in Bittensor subnets. Provide a concise, insightful analysis of the data provided. Focus on key metrics, trends, and actionable insights. Your response should be 3-5 sentences maximum, direct and to the point. Avoid unnecessary explanations or background information. Highlight the most important aspects that would help someone make an informed decision. Always remember to do these: Never mention Net inflow!"
        },
        {
          role: "user",
          content: `Analyze this market data:\n\n${data}`
        }
      ],
      temperature: 0.7,
      max_tokens: 200,
      presence_penalty: 0.1,
      frequency_penalty: 0.1
    });

    return response.choices[0]?.message?.content?.trim() || "Unable to generate analysis.";
  } catch (error) {
    console.error('Error generating market analysis:', error);
    return "Error: Unable to generate market analysis at this time.";
  }
}

export async function generateHolderAnalysis(data: string): Promise<string> {
  try {
    const response = await openai.chat.completions.create({
      model: "gpt-4-turbo-preview",
      messages: [
        {
          role: "system",
          content: "You are a cryptocurrency market analyst specializing in holder distribution analysis. Provide a single clear sentence overview followed by 2-3 insights. Each insight should be on a new line starting with a dash. Keep responses under 4 lines total. Be direct and analytical. Focus on metrics and trends. No fluff."
        },
        {
          role: "user",
          content: `Analyze this holder distribution data:\n\n${data}`
        }
      ],
      temperature: 0.7,
      max_tokens: 200,
      presence_penalty: 0.1,
      frequency_penalty: 0.1
    });

    return response.choices[0]?.message?.content?.trim() || "Unable to generate analysis.";
  } catch (error) {
    console.error('Error generating holder analysis:', error);
    return "Error: Unable to generate holder analysis at this time.";
  }
}

export async function generateMindshareAnalysis(data: string): Promise<string> {
  try {
    const response = await openai.chat.completions.create({
      model: "gpt-4-turbo-preview",
      messages: [
        {
          role: "system",
          content: "You are a cryptocurrency market analyst specializing in mindshare metrics. Provide a single clear sentence overview followed by 2-3 insights. Each insight should be on a new line starting with a dash. Keep responses under 4 lines total. Be direct and analytical. Focus on metrics and trends. No fluff."
        },
        {
          role: "user",
          content: `Analyze this mindshare data:\n\n${data}`
        }
      ],
      temperature: 0.7,
      max_tokens: 300,
      presence_penalty: 0.1,
      frequency_penalty: 0.1
    });

    return response.choices[0]?.message?.content?.trim() || "Unable to generate analysis.";
  } catch (error) {
    console.error('Error generating mindshare analysis:', error);
    return "Error: Unable to generate mindshare analysis at this time.";
  }
}

export async function generateTwitterAnalysis(data: string): Promise<string> {
  try {
    const response = await openai.chat.completions.create({
      model: "gpt-4-turbo-preview",
      messages: [
        {
          role: "system",
          content: "You are a social media analyst specializing in Twitter engagement metrics. Provide a single clear sentence overview followed by 2-3 insights. Each insight should be on a new line starting with a dash. Keep responses under 4 lines total. Be direct and analytical. Focus on metrics and trends. No fluff."
        },
        {
          role: "user",
          content: `Analyze this Twitter engagement data:\n\n${data}`
        }
      ],
      temperature: 0.7,
      max_tokens: 200,
      presence_penalty: 0.1,
      frequency_penalty: 0.1
    });

    return response.choices[0]?.message?.content?.trim() || "Unable to generate analysis.";
  } catch (error) {
    console.error('Error generating Twitter analysis:', error);
    return "Error: Unable to generate Twitter analysis at this time.";
  }
}

export async function generateCompanyAnalysis(tweets: string): Promise<string> {
  try {
    const response = await openai.chat.completions.create({
      model: "gpt-4-turbo-preview",
      messages: [
        {
          role: "system",
          content: "You are an AI industry analyst specializing in blockchain and AI companies. Provide a single clear sentence overview followed by 2-3 insights. Each insight should be on a new line starting with a dash. Keep responses under 4 lines total. Be direct and analytical. Focus on recent developments and metrics. No fluff."
        },
        {
          role: "user",
          content: `Based on these recent tweets, describe this company and their work:\n\n${tweets}`
        }
      ],
      temperature: 0.7,
      max_tokens: 500,
      presence_penalty: 0.1,
      frequency_penalty: 0.1
    });

    return response.choices[0]?.message?.content?.trim() || "Unable to generate company analysis.";
  } catch (error) {
    console.error('Error generating company analysis:', error);
    return "Error: Unable to generate company analysis at this time.";
  }
}

export async function answerQuestion(question: string, tweets: string): Promise<string> {
  try {
    const response = await openai.chat.completions.create({
      model: "gpt-4-turbo-preview",
      messages: [
        {
          role: "system",
          content: "You are an AI assistant with deep knowledge of the Bittensor ecosystem. Provide direct, concise answers in 1-3 lines. Focus on recent, factual information. If discussing multiple topics, use dashes at the start of each line. If you cannot find relevant information, say 'No recent information available.' Never reference sources."
        },
        {
          role: "user",
          content: `Question: ${question}\n\nAvailable information:\n${tweets}`
        }
      ],
      temperature: 0.7,
      max_tokens: 500,
      presence_penalty: 0.1,
      frequency_penalty: 0.1
    });

    return response.choices[0]?.message?.content?.trim() || "No recent information available.";
  } catch (error) {
    console.error('Error answering question:', error);
    return "No recent information available.";
  }
}

export async function generateMarketMovementAnalysis(data: string): Promise<string> {
  try {
    const response = await openai.chat.completions.create({
      model: "gpt-4-turbo-preview",
      messages: [
        {
          role: "system",
          content: `You are a Bittensor subnet analyst. When analyzing whale activity, format your response like this:

Whales are primarily buying [Subnet1], [Subnet2], and [Subnet3].

[Subnet1] is seeing the highest net inflow at $X, with [Subnet2] right behind at $Y. [Subnet3] has attracted $Z in whale investments over the last 24 hours.

Some significant individual transactions include a wallet (5G9z...) that bought $15,000 worth of [Subnet1] in a single transaction about 3 hours ago. Another whale (5FHn...) invested $12,500 in [Subnet2] just yesterday.

The pattern suggests strategic accumulation in [category] subnets, with particular focus on [specific technology trends].

Always mention specific subnets, dollar amounts, and wallet addresses. Never use the word "cryptocurrency" - these are subnets. Be specific and direct. Limit to 4 paragraphs maximum.`
        },
        {
          role: "user",
          content: `Analyze this market movement data:\n\n${data}`
        }
      ],
      temperature: 0.7,
      max_tokens: 500,
      presence_penalty: 0.1,
      frequency_penalty: 0.1
    });

    return response.choices[0]?.message?.content?.trim() || "Unable to analyze market movement.";
  } catch (error) {
    console.error('Error generating market movement analysis:', error);
    return "Error: Unable to analyze market movement at this time.";
  }
}